module.exports = __webpack_public_path__ + "img/video-player/luna-body-63fa23ddfce161c56a483deef3e40f98.svg";